import React from 'react';
import styles from './WelcomePage.scss';
import { Button, Text } from '@wix/design-system';
import Div100vh from 'react-div-100vh';
import HireDesignerExtension from './HireDesignerExtension';
import { OneTapDisclaimer } from './OneTapDisclaimer';

const WelcomePage = props => {
  const { onGoToOnBoarding, onGoToArena, shouldShowHireDesigner, shouldShowOneTapDisclaimer, t } = props;

  const renderedComponent = (
    <Div100vh className={styles.page}>
      <div className={styles.wixLogo} />
      {!shouldShowHireDesigner && <div className={styles.topSpacing} />}
      <div className={styles.main}>
        <div className={styles.title}>
          <Text weight="bold">
            <span className={styles.titleFont}>{t('WELCOME_PAGE_TITLE')}</span>
          </Text>
        </div>
        <div className={styles.subtitle}>
          <Text weight="thin">
            <span className={styles.subtitleFont}>{t('WELCOME_PAGE_SUBTITLE')}</span>
          </Text>
        </div>
        <div className={styles.action}>
          <Button size="large" onClick={onGoToOnBoarding}>
            {t('WELCOME_PAGE_PRIMARY_CTA')}
          </Button>
        </div>
      </div>
      {shouldShowHireDesigner && <HireDesignerExtension onGoToArena={onGoToArena} t={t} />}
      {!shouldShowHireDesigner && <div className={styles.bottomSpacing} />}
      {shouldShowHireDesigner && (
        <div className={styles.image}>
          <div className={styles.disappearingImage}>
            <img width="100%" className={styles.innerImage} />
          </div>
        </div>
      )}
      {!shouldShowHireDesigner && (
        <div className={styles.image}>
          <img width="100%" className={styles.innerImage} />
        </div>
      )}
      {shouldShowOneTapDisclaimer && <OneTapDisclaimer {...props} />}
    </Div100vh>
  );

  return renderedComponent;
};

export default WelcomePage;
